<div>
  <form [formGroup]="infoForm">
    <div class="row">
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.cnpj">
          <div class="material-textfield">
            <input mask="00.000.000/0000-00" placeholder=" " class="form-input" formControlName="cnpj" (blur)="onChangeCnpj()" />
            <label class="required" for="cnpj">CNPJ</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.name">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="name" />
            <label class="required" for="name">Razão Social</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.fantasyName">
          <div class="material-textfield">
            <input class="form-input" placeholder=" " formControlName="fantasyName" />
            <label class="required" for="fantasyName">Nome Fantasia</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.type">
          <div class="material-textfield">
            <ng-select formControlName="type" class="form-input p-0" placeholder="Select tipo da empresa"
              bindLabel="description" [items]="companyTypes$ | async"></ng-select>
            <label class="required" for="type">Tipo da empresa</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.sector">
          <div class="material-textfield">
            <ng-select formControlName="sector" bindLabel="description" class="form-input p-0"
              placeholder="Select Setor" groupBy="group" [items]="companySectors$ | async">
            </ng-select>
            <label class="required" for="sector">Setor</label>
          </div>
        </form-helper>
      </div>
      <div class="col-lg-4 col-md-4 col-sm-12 col-12">
        <form-helper class="form-group" [control]="controls.activity">
          <div class="material-textfield">
            <input type="text" class="form-input" placeholder=" " formControlName="activity" />
            <label class="required" for="activity">Atividade</label>
          </div>
        </form-helper>
      </div>
      <div class="col-12" *ngIf="secondaryActivities.length > 0">
        <label class="form-label mb-2">Atividades Secundárias</label>
        <div class="row">
          <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngFor="let activity of secondaryActivities">
            <div class="material-textfield">
              <input type="text" class="form-input" [value]="activity.text" readonly placeholder=" " />
              <!-- <label>{{ activity.code }}</label> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
